export const SearchParamKeyDefinition = Object.freeze({
    'distance': 'r',
    'datePosted': 'dp',
    'salaryType': 'st',
    'salaryMin': 'sl',
    'salaryMax': 'su',
    'jobType': 'jt',
    'features': 'f',
    'type': 'type',
    'page': 'pg',
    'uniqueId': 'jb',
});
